export const quizkyCrampeteAPI = "https://6rola3qg3l.execute-api.ap-south-1.amazonaws.com/v1"